/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Project_File_AriaInputs */



/**
* | output |
* | --- |
* | "Export project file" |
*
* @param {File_Export_Project_File_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_project_file_aria = /** @type {((inputs?: File_Export_Project_File_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Project_File_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter le fichier de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta file di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт файла проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar archivo de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出项目文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトファイルをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de projeto de exportação")
	return /** @type {LocalizedString} */ ("Export project file")
});